/**
 * Regroupe une liste plate de DestinationTile par zone géographique.
 *
 * Exemple concret : `[{ name: 'Inde', zone: { slug: 'asia', position: 3, … } },
 * { name: 'Mexique', zone: { slug: 'americas', position: 2, … } }]` →
 * `[{ slug: 'americas', tiles: [Mexique] }, { slug: 'asia', tiles: [Inde] }]`.
 *
 * Tiles sans zone (`zone: null`) sont collectées sous le groupe `{ slug: 'autres',
 * label: 'Autres', position: Infinity }` placé en dernière position.
 */

import type { DestinationTile } from '@/app/api/lib/destinations/destination.types';

export type ZoneGroup = {
    slug: string;
    label: string;
    position: number;
    tiles: DestinationTile[];
};

export function groupByZone(tiles: ReadonlyArray<DestinationTile>): ZoneGroup[] {
    const byZone = new Map<string, ZoneGroup>();
    const noZoneTiles: DestinationTile[] = [];

    for (const tile of tiles) {
        if (!tile.zone) {
            noZoneTiles.push(tile);
            continue;
        }
        const existing = byZone.get(tile.zone.slug);
        if (existing) {
            existing.tiles.push(tile);
        } else {
            byZone.set(tile.zone.slug, {
                slug: tile.zone.slug,
                label: tile.zone.label,
                position: tile.zone.position,
                tiles: [tile],
            });
        }
    }

    const sorted = Array.from(byZone.values()).sort((a, b) => a.position - b.position);
    const autresGroup: ZoneGroup[] =
        noZoneTiles.length > 0
            ? [{ slug: 'autres', label: 'Autres', position: Infinity, tiles: noZoneTiles }]
            : [];

    return [...sorted, ...autresGroup];
}
